import data from 'dsv!../../data/sewing_terms.csv';

/**
 * Retrieves all data
 * @return {array} terms
 */
function getData() {
    return data;
}
/**
 * Lists all the available languages
 * @return {[type]} [description]
 */
function getLangs() {
    let langs = [];
    for (let lang in data[0]){
        if (lang){
            langs.push(lang);
        }
    }
    return langs;
}

/**
 * [getTerms description]
 * @param  {[type]} srcLang [description]
 * @return {[type]}          [description]
 */
function getTerms(srcLang) {
    var count = 0;
    var items = [];
    data.forEach(function(item){
        var term = item[srcLang];
        if (term){
            items.push({
                key:  'key-'+count,
                term: term
            });
        }
        count++;
    });
    return items;
}

/**
 * Gets a term at a given key, or index
 * @param  {[type]} tgtLang [description]
 * @param  {[type]} idx     [description]
 * @return {[type]}         [description]
 */
function getTranslationForIdx(tgtLang, idx){
    let term = 'no translation';
    let tgtTerms = getTerms(tgtLang);
    tgtTerms.forEach(function(termObj){
        if (idx === termObj.key){
            term = termObj.term;
        }
    });
    return term;
}

function termExistsForLang(term, lang){
    term = term.toLowerCase();
    for (let key in data){
        if ({}.hasOwnProperty.call(data, key)) { // guard against for..in wierdness
            if (data[key][lang].toLowerCase() === term){
                return true;
            }
        }
    }
    return false;
}

/**
 * [getTranslationForTerm description]
 * @param  {[type]} srcLang [description]
 * @param  {[type]} tgtLang [description]
 * @param  {[type]} term    [description]
 * @return {[type]}         [description]
 */
function getTranslationForTerm(srcLang, tgtLang, term){
    let srcTerms = getTerms(srcLang);
    let srcIdx;
    srcTerms.forEach(function(termObj){
        if (termObj.term == term){ // eslint-disable-line eqeqeq
            srcIdx = termObj.key;
        }
    });
    return getTranslationForIdx(tgtLang, srcIdx);
}

function matchStateToTerm (term, value) {
  return (term.term.toLowerCase().indexOf(value.toLowerCase()) !== -1);
}

function sortTerms (a, b, term) {
  return (
    a.term.toLowerCase().indexOf(term.toLowerCase()) >
    b.term.toLowerCase().indexOf(term.toLowerCase()) ? 1 : -1
  )
}

export {getData, getLangs, getTerms, matchStateToTerm, sortTerms, getTranslationForIdx, getTranslationForTerm, termExistsForLang};



/** WEBPACK FOOTER **
 ** ./src/terms/index.js
 **/